export default "__VITE_ASSET__0f2b94da__"